import { requestPermission } from '$lib/utils/notifications';
import { storable } from '$lib/utils/storable';
import { derived, writable } from 'svelte/store';

export const token = storable('token', null);
export const user = writable(null);
// ISO date of the absolute end of the session, returned at login
export const sessionExpiresAt = storable('sessionExpiresAt', null);

export const init = (initToken) => {
  if (initToken) {
    token.set(initToken);
  }
};

export const UserRoles = {
  psychologist: 1,
  nurse: 2,
  physiotherapist: 3,
  doctor: 4,
  assistantNurse: 5,
  operationsSupport: 6,
  csm: 7,
};

// Derived store for roles based on token
export const ROLES = derived(user, ($user) => {
  return {
    all: true,
    supervisor: !!$user?.isSupervisor,
    developer: !!$user?.developer,
    medic: [
      UserRoles.psychologist,
      UserRoles.nurse,
      UserRoles.physiotherapist,
      UserRoles.doctor,
      UserRoles.assistantNurse,
    ].includes($user?.roleId),
    support: $user?.roleId === UserRoles.operationsSupport,
    csm: $user?.roleId === UserRoles.csm,
  };
});

let hadToken = false;
token.subscribe((value) => {
  if (value && !hadToken) requestPermission();
  hadToken = !!value;
});

token.subscribe((value) => {
  if (!value) sessionExpiresAt.set(null);
});
